export enum CustomAppEvents {
  CLARITY_LOADED = 'clarityLoaded',
  ONE_TRUST_LOADED = 'oneTrustLoaded',
  TIKTOK_PIXEL_LOADED = 'tiktokPixelLoaded',
  FACEBOOK_PIXEL_LOADED = 'facebookPixelLoaded',
  BING_ADS_LOADED = 'bingAdsLoaded',
  TABOOLA_PIXEL_LOADED = 'taboolaPixelLoaded',
  AXON_LOADED = 'axonLoaded',
  SNAPCHAT_PIXEL_LOADED = 'snapchatPixelLoaded',
}
